export enum CREATE_ACCOUNT_STEPS {
  email = 'email',
  password = 'password',
  checkEmailCode = 'check_email_code',
  login = 'login',
}

export enum FORM_NAMES {
  email = 'email',
  password = 'password',
  email_code = 'email_code',
}
